import { notifySuccess } from 'utils/common'
import axios from 'axios'

// class Gateway {
//   constructor (data) {
//     this.sn = data.sn // string 16进制的sn号
//     this.remoteAddress = data.remoteAddress // string 远程地址
//     this.serverAddress = data.serverAddress // string 服务器地址
//     this.createdAt = data.creationTime || '' // date 创建时间
//     this.loginTime = data.loginTime || '' // date 入网时间
//     this.securityVersion = data.securityVersion // number 加密版本号

//     const { messageType, branchNo, versionNo, firmwareVersion, protocolVersion, simNo, hardwareVersion } = data.gatewayLoginRequest // 入网记录
//     this.joinLog = {
//       messageType: messageType, // number 指令类型 1-网关，2-节点
//       branchNo: branchNo, // number 指令分支号
//       versionNo: versionNo, // number 指令版本号
//       firmwareVersion: firmwareVersion, // number 固件版本
//       protocolVersion: protocolVersion, // number 协议版本
//       simNo: simNo, // number sim卡号
//       hardwareVersion: hardwareVersion // number 硬件版本
//     }
//   }
// }

/**
 * 获取网关列表
 * @param  {*Number} pageNo 当前页
 * @param  {*Number} pageSize 每页条数
 * @return {Array}
 */
// const mockListData = {
//   recordCount: 20,
//   records: [
//     {
//       remoteAddress: '127.0.0.1:8080',
//       creationTime: 1510135864117,
//       sn: 268435457,
//       loginTime: 1510135864117,
//       securityVersion: 1,
//       gatewayLoginRequest: {
//         messageType: 1,
//         branchNo: 0,
//         versionNo: 0
//       }
//     }
//   ]
// }
export const getList = async (params) => {
  let path = ''
  if (location.pathname.indexOf('solar') !== -1) {
    path = 'solar'
  } else {
    path = 'smart-grid'
  }
  const { data: { records, recordCount, pageCount } } = await axios.get(`v1/${path}/sys-downs/client`, { params })
  // await new Promise(resolve => {
  //   setTimeout(() => {
  //     console.log(params)
  //     resolve()
  //   }, 2000)
  // })
  // const { records, recordCount } = mockListData
  // const list = records.map(item => new Gateway(item))
  return { list: records, pageCount, total: recordCount }
}

/**
 * 断开连接
 * @param {*String} sn -十进制sn号
 */
export const disconnect = async (sn) => {
  let path = ''
  if (location.pathname.indexOf('solar') !== -1) {
    path = 'solar'
  } else {
    path = 'smart-grid'
  }
  try {
    const {data: { success }} = await axios.post(`v1/${path}/sys-downs/disconnect/${sn}`)
    return success
    // notifySuccess('下发成功')
  } catch (e) {
  }
}

/**
 * 下发通用指令
 * @param {*Object} data
 */
export const sendCommonCommand = async (data) => {
  await new Promise(resolve => {
    setTimeout(() => {
      resolve()
    }, 2000)
  })
  notifySuccess('下发成功')
}

/**
 * 获取参数
 * @param {*String} sn 16进制的sn号
 * @return {Object}
 */
export const getConfigData = async (sn) => {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve('假数据')
    }, 2000)
  })
}

/**
 * 读取策略
 * @param {*String} sn 16进制的sn号
 * @return {Object}
 */
export const getStrategyData = async (sn) => {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve('策略')
    }, 2000)
  })
}

/**
 * 重启系统
 * @param  {*String} snHex 16进制的sn号
 * @return {Object}
 */
export const restartSystem = async (snHex) => {
  // await axios.post('v1/solar/sys-downs/cmd/restart-system', { snHex })
  await new Promise(resolve => {
    setTimeout(() => {
      console.log(snHex)
      resolve()
    }, 2000)
  })
  notifySuccess('重启系统成功')
}

/**
 * 重启充电
 * @param  {*String} snHex 16进制的sn号
 * @return {Object}
 */
export const restartCharge = async (snHex) => {
  // await axios.post('v1/solar/sys-downs/cmd/restart-charge', { snHex })
  await new Promise(resolve => {
    setTimeout(() => {
      console.log(snHex)
      resolve()
    }, 2000)
  })
  notifySuccess('重启充电成功')
}
